import React, { Component } from 'react';
import { Link } from "react-router-dom";
import API from "../../config/api";

export class NewsView extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
           news_id: 1,
           news: []
        }
      }
      UNSAFE_componentWillMount() {
        this.getParam("id");
        this.getOneNews();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.news_id = id;
        // this.setState({category_id : id})
        this.setState({})
        // return 
      }
    
      getOneNews = async () => {
        try {
          let query = `news_id=${this.state.news_id}`
          let results = await API.getOneNews(query);
    
          let data = results.data;
          console.log(data)
          this.setState({ news : data });
    
        } catch (error) {
          console.log(error)
        }
      }
    
  render() {
    return (
        <div className="col-12">
            <form className="card">
                <h4 className="card-title"><strong>News</strong></h4>

                <div className="card-body row">

                    <div className="col-md-6">
                      <div className="form-group">
                          <label className="require" for="input-required">Title Kh</label>
                          <input type="text" className="form-control" id="input-required" value={this.state.news.title_kh} onChange={this.handelInput} />
                      </div>
                      <div className="form-group">
                          <label>Description Kh</label>
                          <textarea className="form-control" type="text" value={this.state.news.description_kh} onChange={this.handelInput} />
                      </div>
                      
                    {/* <div className="form-group">
                        <label for="inputState" className="col-form-label">Parent</label>
                        <select id="inputState" className="form-control">
                        <option>Short Film</option>
                        <option>Funny</option>
                        <option>Love story</option>
                        <option>Sad story</option>
                        </select>
                    </div> */}
                    
                    </div>


                    <div className="col-md-6">
                      <div className="form-group">
                            <label className="require" for="input-required">Title en</label>
                            <input type="text" className="form-control" id="input-required" value={this.state.news.title_en} onChange={this.handelInput} />
                      </div>
                      <div className="form-group">
                          <label>Description Kh</label>
                          <textarea className="form-control" type="text" value={this.state.news.description_kh} onChange={this.handelInput} />
                      </div>
                    </div>
                    <div className="col-md-6">
                    <div className="form-group">
                        <label>Thumbnail</label>
                        <img className='h-300px w-fullscreen' src={this.state.news.thumbnail_url} alt="..." />
                        <br />
                        {/* <input type="file" data-provide="dropify" /> */}
                    </div>
                    </div>
                    

                    
                </div>

                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/newsindex">Back</Link>
                </footer>
            </form>
        </div>
    )
  }
}

export default NewsView